import { render } from "./LoginSuccessPage.vue?vue&type=template&id=5c472178"
import script from "./LoginSuccessPage.vue?vue&type=script&lang=js"
export * from "./LoginSuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__